// Legacy stub. Renders nothing — the old proposal dialog was tied to
// the legacy contract model. Clean redesign on top of V2 happens in
// a follow-up slice. Keeping the file so Messages.tsx still compiles.

import React from 'react';
import type { ProposalPayload } from '../../types/thread';

interface ProposalDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (payload: ProposalPayload) => void;
  type: 'REQUEST' | 'SUBMIT';
  initialData?: ProposalPayload;
  readOnly?: boolean;
  currentUserId?: string;
}

export const ProposalDialog: React.FC<ProposalDialogProps> = () => null;
